rs.module("controls/components/delete-prompt",

    [
        "ui/framework/client-templates"
    ],

    function (clientTemplates) {

        // Initialize
        function initialize(selector, position, templateKey) {

            $(document).on("click", selector, function (event) {
                event.preventDefault();

                // If this is a form submit button, validate the form and make sure it's valid before
                // continuing.
                if ($(this).is("button[type='submit']") && !$(this).closest("form").validate().form()) {
                    return;
                }

                showPrompt($(this), position, templateKey);
            });
        }

        // Show the toolbar delete prompt
        function showPrompt(deleteElement, position, templateKey) {

            // Toolbar is the sibling immediately following this delete
            var promptPopup = $(clientTemplates.render(templateKey));

            // Position it
            $("body").append(promptPopup);
            promptPopup.css("left", (deleteElement.offset().left) + "px");
            promptPopup.css("top", (deleteElement.offset().top) + "px");
            promptPopup[0].style.setProperty('--delete-element-height', (deleteElement[0].getBoundingClientRect().height + "px"));
            promptPopup[0].style.setProperty('--delete-element-width', (deleteElement[0].getBoundingClientRect().width + "px"));
            promptPopup.toggleClass(position, true);
            promptPopup.toggleClass("_visible", true);

            // If we click anywhere outside the prompt, hide the prompt
            $(document).on(`mouseup`, function (e) {
                if (!promptPopup.is(e.target) && promptPopup.has(e.target).length === 0) {
                    destroyPrompt();
                }
            });

            // Handle the delete
            promptPopup.on(`click`, "._delete", function () {

                // Prevent clicking any more buttons
                $(this).siblings("button").addBack().prop("disabled", true);

                // A link (should have an href for the backend DELETE action)
                if (deleteElement.is("a")) {
                    $.ajax({
                        url: deleteElement.attr("href"),
                        type: "DELETE",
                        delayInformationalMessages: true
                    })
                        .done(function (_, __, xhr) {

                            // Ajax redirect
                            if (xhr.status == 202) {
                                window.location = xhr.getResponseHeader("location");
                            }
                            // Success, just reload
                            else {
                                // Reload the current url.  We do not use window.location.reload() becuase that will cause
                                // a POST if the current page was loaded via a POST.  We want a GET, so will just re-set the 
                                // window location
                                window.location = window.location.href;
                            }
                        })
                        .fail(function (xhr, _, error) {

                            console.log(error || xhr.responseJSON || "A error occurred while processing the delete.");

                            destroyPrompt();
                        });
                }
                // Form submit button - just submit the form
                else if (deleteElement.is("button[type='submit']")) {
                    deleteElement.closest("form").submit();
                }
                else {
                    throw new Error("Invalid delete link UI element.");
                }
            });

            // Cancel button hides the prompt
            promptPopup.on(`click`, "._cancel", destroyPrompt);

            // Destory the toolbar delete prompt
            function destroyPrompt() {

                // Hide the prompt and when the css fade ends remoe it from the DOM entirely
                promptPopup
                    .toggleClass("_visible", false)
                    .on("transitionend", function () { promptPopup.remove(); });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);